import React from 'react';

function SearchIcon(props) {
  return (
    <span>
      <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}>
        <path
          d="M6 0.722168C3.09143 0.722168 0.722168 3.09143 0.722168 6C0.722168 8.90857 3.09143 11.2778 6 11.2778C7.25914 11.2778 8.41617 10.8328 9.32471 10.0933L13.0327 14.7383C13.0327 14.7383 13.8449 14.859 14.3491 14.3335C14.8569 13.804 14.7378 13.0337 14.7378 13.0337L10.0933 9.32471C10.8328 8.41617 11.2778 7.25914 11.2778 6C11.2778 3.09143 8.90857 0.722168 6 0.722168ZM6 1.77783C8.33814 1.77783 10.2222 3.66186 10.2222 6C10.2222 8.33814 8.33814 10.2222 6 10.2222C3.66186 10.2222 1.77783 8.33814 1.77783 6C1.77783 3.66186 3.66186 1.77783 6 1.77783Z"
          fill="#AAAAAA"
        />
      </svg>
    </span>
  );
}

export default SearchIcon;
